import axios from 'axios'
import { apiUrl, driverMapUrl } from '../apiUrl'
import { isEmpty } from 'lodash'
import moment from 'moment'

import { parseAs } from 'utils/functions/doformsDateUtil'

const url = apiUrl()
const apiHeader = (token) => {
	return {
		Accept: 'application/json',
		Authorization: `Bearer ${token}`,
	}
}

const driverMapApi = {
	getUserByEmail(userEmail, token) {
		return axios.get(`${url}/integrations/110/users?email=${userEmail}`, {
			headers: apiHeader(token),
		})
	},
	getDrivesByUserId(props) {
		const { showHistory, token, userOffset, driveId, isMostRecent, ...params } = props
		let queryParams = ''
		if (!showHistory) {
			delete params['end_after']
			delete params['start_before']
			params['limit'] = 1
		} else {
			// add 1s to get next day
			params['start_before'] = params['start_before'] + 1
		}

		if (driveId) {
			params['limit'] = 1000
			delete params['end_after']
			delete params['start_before']
		} else if (isMostRecent) {
			params['limit'] = 1
			delete params['end_after']
			delete params['start_before']
		}

		Object.keys(params).forEach((key, index) => {
			const value = params[key]
			if (!value) return
			queryParams = queryParams + (index === 0 ? `?${key}=${value}` : `&${key}=${value}`)
		})

		return axios.get(`${url}/integrations/110/drives${queryParams}`, {
			headers: apiHeader(token),
		})
	},
	getDriveLocations(props) {
		const { user_id, drive_id, token, ...params } = props
		let queryParams = ''
		Object.keys(params).forEach((key, index) => {
			const value = params[key]
			if (isEmpty(value)) return
			queryParams = queryParams + (index === 0 ? `?${key}=${value}` : `&${key}=${value}`)
		})

		queryParams += '?sample_rate=0.5' // Default

		return axios.get(
			`${url}/integrations/110/users/${user_id}/drives/${drive_id}/locations${queryParams}`,
			{
				headers: apiHeader(token),
			}
		)
	},
	getDriveEvents(props) {
		const { user_id, drive_id, token } = props

		return axios.get(`${url}/integrations/110/users/${user_id}/drives/${drive_id}/events`, {
			headers: apiHeader(token),
		})
	},
	getDriverHeartBeat(props) {
		const { token, user_id, showHistory, isMostRecent, ...params } = props
		let queryParams = ''

		params['before'] = params['before'] + 1
		if (!showHistory) {
			delete params['after']
			delete params['before']
			params['limit'] = 1
		}

		if (isMostRecent) {
			params['limit'] = 1
		}

		if (!params['after'] || isNaN(params['after'])) {
			delete params['after']
		}

		Object.keys(params).forEach((key, index) => {
			const value = params[key]
			if (!value) return
			queryParams = queryParams + (index === 0 ? `?${key}=${value}` : `&${key}=${value}`)
		})
		return axios.get(`${url}/integrations/110/users/${user_id}/heartbeats${queryParams}`, {
			headers: apiHeader(token),
		})
	},
}

export default driverMapApi
